import type { RouterConfig } from "@nuxt/schema";
import { LOCALE_PATH_SEGMENTS, shouldRegisterLocalizedRoute } from "~/utils/i18n-locale-routes";

/** 为首页与 /seer/* 注册 /tw、/en 前缀路由：默认中文无前缀，英文 /en，台湾地区 /tw */
export default {
	routes: _routes => {
		const localizedRoutes = [];

		for (const route of _routes) {
			const path = route.path as string;
			if (!shouldRegisterLocalizedRoute(path)) continue;

			for (const segment of LOCALE_PATH_SEGMENTS) {
				const isHome = path === "/";
				const localizedPath = isHome ? `/${segment}` : `/${segment}${path}`;
				localizedRoutes.push({
					...route,
					path: localizedPath,
					// 首页同时匹配 /en/、/tw/（规范地址由 middleware 从 /en、/tw 301 过去）
					...(isHome ? { alias: [`/${segment}/`] } : {}),
					name: route.name ? `${segment}___${String(route.name)}` : undefined,
					meta: {
						...(route.meta || {}),
						localeSegment: segment,
					},
				});
			}
		}

		return [..._routes, ...localizedRoutes];
	},
} satisfies RouterConfig;
